import React, { useEffect, useState } from 'react';

import { arrayOf, bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { LINE_ITEM_NIGHT, LINE_ITEM_DAY, propTypes } from '../../util/types';
import { maxLength, required, composeValidators } from '../../util/validators';
import {
  Form,
  Button,
  FieldTextInput,
  FieldCurrencyInput,
  FieldCheckboxGroup,
  FieldRadioButton,
  ExternalLink,
  FieldSelect,
} from '../../components';
// import CustomCategorySelectFieldMaybe from './CustomCategorySelectFieldMaybe';
import CustomRoomtypeSelectFieldMaybe from './CustomRoomtypeSelectFieldMaybe';
// import CustomAccomodationtypeSelectFieldMaybe from './CustomAccomodationtypeSelectFieldMaybe';

import css from './EditListingDescriptionForm.css';

import config from '../../config';
import * as validators from '../../util/validators';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';

import { findOptionsForSelectFilter } from '../../util/search';
import arrayMutators from 'final-form-arrays';

import { Prompt } from 'react-router';
import { confirmError } from '../../ducks/Auth.duck';
import { configOptions } from 'final-form';

// useEffect(()=>{

// var classes = ["info1", "info2", "info3","info4","info5"];
// var elms = {};
// var n = {}, nclasses = classes.length;

// function changeColor(classname, color) {
//   for (var k = 0; k < nclasses; k++) {
//     var curClass = classes[k];
//     elms[curClass] = document.getElementsByClassName(curClass);
//     n[curClass] = elms[curClass].length;
//     var curN = n[curClass];
//   for (var i = 0; i < curN; i++) {
//     elms[curClass][i].onmouseover = function (e) {
//       <div>information</div>

// import getCategoryCodes from '../../translations/categoryCodes';

const { Money } = sdkTypes;

const CATEGORIES_MAX_LENGTH = 2;

// const TITLE_MAX_LENGTH = 60;

const EditListingDescriptionFormComponent = props => {
  const { initialValues } = props;
  console.log('INITIALVALUES:___', initialValues);
  const [price, setPrice] = useState(initialValues.price ? initialValues.price.amount : 0);
  const [roomType, setroomType] = useState(initialValues.roomtype ? initialValues.roomtype : '');
  const getOnChange = value => {
    if (value != null) setPrice(value.amount);
    else setPrice(0);
  };
  // console.log("CONFIG: ", config.currencyConfig)
  const currencyCheck = initialValues.customCurrency;
  // initialValues.customCurrency == "Dollar" ? config.currencyConfig.currency = "USD" : config.currencyConfig.currency = "EUR"
  // console.log("CONFIG: ", config.currencyConfig)

  //When we define a customCurrency we have to change the value
  useEffect(() => {
    const priceCurrencyChanger = document
      .getElementsByClassName('currencyChanger')[0]
      .querySelector('input');
    console.log('CURRENCYCHANGER: ', priceCurrencyChanger);
    priceCurrencyChanger.value = priceCurrencyChanger.value.replace(
      '$',
      currencyCheck == 'Dollar' ? '$' : ''
    );
    priceCurrencyChanger.onchange = function() {
      priceCurrencyChanger.value = priceCurrencyChanger.value.replace(
        '$',
        currencyCheck == 'Dollar' ? '$' : ''
      );
    };
  });

  return (
    <FinalForm
      {...props}
      mutators={{ ...arrayMutators }}
      render={formRenderProps => {
        const {
          roomtypes,
          // accomodationtypes,
          // categories,
          className,
          disabled,
          ready,
          handleSubmit,
          intl,
          invalid,
          pristine,
          saveActionMsg,
          updated,
          updateInProgress,
          fetchErrors,
          filterConfig,
          name,
          languages,
          isNewListingFlow,
        } = formRenderProps;

        // const titleMessage = intl.formatMessage({ id: 'EditListingDescriptionForm.title' });
        // const titlePlaceholderMessage = intl.formatMessage({
        //   id: 'EditListingDescriptionForm.titlePlaceholder',
        // });
        // const titleRequiredMessage = intl.formatMessage({
        //   id: 'EditListingDescriptionForm.titleRequired',
        // });
        // const maxLengthMessage = intl.formatMessage(
        //   { id: 'EditListingDescriptionForm.maxLength' },
        //   {
        //     maxLength: TITLE_MAX_LENGTH,
        //   }
        // );

        // const maxLength60Message = maxLength(maxLengthMessage, TITLE_MAX_LENGTH);

        const customCurrencyKey = 'customCurrency';
        const customCurrencyOptions = findOptionsForSelectFilter(customCurrencyKey, filterConfig);

        const maxLengthMessageCategories = intl.formatMessage(
          { id: 'EditListingDescriptionForm.maxLength2' },
          {
            maxLength: CATEGORIES_MAX_LENGTH,
          }
        );
        const maxLength2Message = maxLength(maxLengthMessageCategories, CATEGORIES_MAX_LENGTH);

        // const languagesTip = intl.formatMessage({
        //   id: 'EditListingDescriptionForm.languagesTip',
        // });
        // const languagesMessage = intl.formatMessage({
        //   id: 'EditListingDescriptionForm.languages',
        // });
        const languagesPlaceholderMessage = intl.formatMessage({
          id: 'EditListingDescriptionForm.languagesPlaceholder2',
        });
        // const languagesRequiredMessage = intl.formatMessage({
        //   id: 'EditListingDescriptionForm.languagesRequired',
        // });

        const { updateListingError, createListingDraftError, showListingsError } =
          fetchErrors || {};
        const errorMessageUpdateListing = updateListingError ? (
          <p className={css.error}>
            <FormattedMessage id="EditListingDescriptionForm.updateFailed" />
          </p>
        ) : null;

        // This error happens only on first tab (of EditListingWizard)
        const errorMessageCreateListingDraft = createListingDraftError ? (
          <p className={css.error}>
            <FormattedMessage id="EditListingDescriptionForm.createListingDraftError" />
          </p>
        ) : null;

        const errorMessageShowListing = showListingsError ? (
          <p className={css.error}>
            <FormattedMessage id="EditListingDescriptionForm.showListingFailed" />
          </p>
        ) : null;

        const unitType = config.bookingUnitType;
        const isNightly = unitType === LINE_ITEM_NIGHT;
        const isDaily = unitType === LINE_ITEM_DAY;
        const isShared = roomType === 'shared_bedroom';
        console.log(roomType);
        const translationKey = isShared
          ? 'EditListingPricingForm.pricePerBed'
          : isNightly
          ? 'EditListingPricingForm.pricePerNight'
          : isDaily
          ? 'EditListingPricingForm.pricePerDay'
          : 'EditListingPricingForm.pricePerUnit';

        const pricePerUnitMessage = intl.formatMessage({
          id: translationKey,
        });

        const pricePlaceholderMessage = intl.formatMessage({
          id: 'EditListingPricingForm.priceInputPlaceholder',
        });

        const priceRequired = validators.required(
          intl.formatMessage({
            id: 'EditListingPricingForm.priceRequired',
          })
        );
        const minPrice = new Money(config.listingMinimumPriceSubUnits, config.currency);
        const minPriceRequired = validators.moneySubUnitAmountAtLeast(
          intl.formatMessage(
            {
              id: 'EditListingPricingForm.priceTooLow',
            },
            {
              minPrice: formatMoney(intl, minPrice),
            }
          ),
          config.listingMinimumPriceSubUnits
        );
        const priceValidators = config.listingMinimumPriceSubUnits
          ? validators.composeValidators(priceRequired, minPriceRequired)
          : priceRequired;

        const classes = classNames(css.root, className);
        const submitReady = (updated && pristine) || ready;
        const submitInProgress = updateInProgress;
        const submitDisabled = invalid || disabled || submitInProgress;

        const options = findOptionsForSelectFilter('category', filterConfig);

        const languageOptions = findOptionsForSelectFilter('languages', filterConfig);

        const roomtypeOptions = findOptionsForSelectFilter('roomtype', filterConfig);

        // console.log(options);
        const roomTypeUpdate = e => {
          //var val = document.getElementById(e) ? document.getElementById(e). : '';
          var c = e.target ? e.target.value : '';
          c = roomType;
          setroomType(e);
        };

        const priceCalc =
          price !== 0 ? (
            <div className={css.sectionPrice}>
              <label>
                <FormattedMessage id="EditListingDescriptionForm.priceCalcFee" /> ={' '}
                {currencyCheck == 'Dollar' ? '$' : '€'}
                {Math.round(price * 0.0015 * 100) / 100}
              </label>

              <label>
                <FormattedMessage id="EditListingDescriptionForm.priceCalcEarn" /> ={' '}
                {currencyCheck == 'Dollar' ? '$' : '€'}
                {Math.round(price * 0.0085 * 100) / 100}
              </label>
            </div>
          ) : null;

        const customCurrencyRequired = required(
          intl.formatMessage({
            id: 'EditListingCustomCurrencyForm.customCurrencyRequired',
          })
        );

        const customCurrencyPlaceholder = intl.formatMessage({
          id: 'EditListingCustomCurrencyForm.customCurrencyPlaceholder',
        });

        return (
          <Form className={classes} onSubmit={handleSubmit}>
            <Prompt
              when={!pristine && !isNewListingFlow}
              message="You have unsaved changes, are you sure you want to leave?"
            />
            {errorMessageCreateListingDraft}
            {errorMessageUpdateListing}
            {errorMessageShowListing}
            {/* <FieldTextInput
            id="title"
            name="title"
            className={css.title}
            type="text"
            label={titleMessage}
            placeholder={titlePlaceholderMessage}
            maxLength={TITLE_MAX_LENGTH}
            validate={composeValidators(required(titleRequiredMessage), maxLength60Message)}
            autoFocus
          /> */}

            <div className={css.tip}>
              <p>
                <FormattedMessage id="EditListingDescriptionForm.intro" />
              </p>
            </div>

            <br />

            <div className={css.sectionTitle}>
              <FormattedMessage id="EditListingDescriptionForm.roomtypeLabel" />
            </div>

            <div className={css.tip}>
              <p>
                <FormattedMessage id="EditListingDescriptionForm.roomtypeTip" />
              </p>
            </div>
            
            <CustomRoomtypeSelectFieldMaybe
              id="roomtype"
              name="roomtype"
              categories={roomtypes}
              intl={intl}
              update={roomTypeUpdate}
              selectedroom={roomType}
            />
              
            {/* <FieldCheckboxGroup
              className={css.description}
              id="roomtype"
              name="roomtype"
              options={roomtypeOptions}
            /> */}

            <br />

            <div className={css.priceSection}>
              <label>
                <FormattedMessage id="EditListingDescriptionForm.priceSection" />
              </label>
              <br></br>
              <p className={css.customCurrencyDescription}>
                <FormattedMessage id="EditListingDescriptionForm.customCurrencyDescription" />
              </p>
            </div>
            <div className={css.customCurrencyTitle}>
              <label>
                <FormattedMessage id="EditListingDescriptionForm.customCurrencyTitle" />
              </label>
            </div>
            <FieldSelect
              className={css.customCurrency}
              name="customCurrency"
              id="customCurrency"
              validate={customCurrencyRequired}
            >
              <option value="">{customCurrencyPlaceholder}</option>
              {customCurrencyOptions.map(c => (
                <option key={c.key} value={c.key}>
                  {c.label}
                </option>
              ))}
            </FieldSelect>
            <br />
            {console.log('PRICELABELCHECK:____', pricePlaceholderMessage)}
            <FieldCurrencyInput
              id="price"
              name="price"
              className={css.description + ' currencyChanger'}
              // autoFocus
              label={pricePerUnitMessage}
              placeholder={pricePlaceholderMessage}
              currencyConfig={config.currencyConfig}
              getOnChange={getOnChange.bind(this)}
              validate={priceValidators}
            />

            {priceCalc}
            <div className={css.tip}>
              <p>
                <p style={{ fontWeight: 'bold' }}>
                  <FormattedMessage
                    style={{ fontWeight: 'bold' }}
                    id="EditListingDescriptionForm.priceTip1"
                  />
                </p>
                <FormattedMessage id="EditListingDescriptionForm.priceTip" />
                <ExternalLink href="https://www.xe.com/de/currencyconverter/" target="_blank">
                  {' '}
                  <FormattedMessage id="EditListingDescriptionForm.priceTipLink" />
                </ExternalLink>
                <FormattedMessage id="EditListingDescriptionForm.priceTipEnd" />
              </p>
            </div>
            <br />

            <br></br>
            {/* <CustomAccomodationtypeSelectFieldMaybe
            id="accomodationtype"
            name="accomodationtype"
            categories={accomodationtypes}
            intl={intl}
          />
          <br /> */}

            {/* <CustomCategorySelectFieldMaybe
            id="category"
            name="category"
            categories={categories}
            intl={intl}
          />
          <br /> */}
            <div className={css.sectionTitle}>
              <FormattedMessage id="EditListingDescriptionForm.categoryLabel" />
            </div>

            <div className={css.tip}>
              <p>
                <FormattedMessage id="EditListingDescriptionForm.categoryTip" />
              </p>
            </div>
            <FieldCheckboxGroup
              className={css.description}
              id={name}
              name={name}
              options={options}
              validate={composeValidators(
                required(maxLengthMessageCategories),
                maxLength2Message,
                validators.requiredFieldArrayCheckbox('one is required')
              )}
            />

            <br />

            <div className={css.sectionTitle}>
              <FormattedMessage id="EditListingDescriptionForm.languages" />
            </div>

            <div className={css.tip}>
              <p>
                <FormattedMessage id="EditListingDescriptionForm.languagesPlaceholder" />
              </p>
            </div>

            <FieldCheckboxGroup
              className={css.description}
              id={languages}
              name={languages}
              options={languageOptions}
            />

            <div className={css.tip2}>
              <p>
                <FormattedMessage
                  // style={{ fontWeight: 'bold' }}
                  id="EditListingDescriptionForm.languagesTip"
                />
              </p>
            </div>

            <FieldTextInput
              id="otherLanguages"
              name="otherLanguages"
              className={css.otherLanguages}
              type="textarea"
              label={' '}
              placeholder={languagesPlaceholderMessage}
            />

            <FieldTextInput
              style={{ display: 'none' }}
              type="textarea"
              id="otherLanguages_de"
              name="otherLanguages_de"
              initialValue={'Übersetzung hinzufügen'}
            />

            <Button
              className={css.submitButton}
              type="submit"
              inProgress={submitInProgress}
              disabled={submitDisabled}
              ready={submitReady}
            >
              {saveActionMsg}
            </Button>
          </Form>
        );
      }}
    />
  );
};

EditListingDescriptionFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  fetchErrors: null,
  filterConfig: config.custom.filters,
};

EditListingDescriptionFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  name: string.isRequired,
  filterConfig: propTypes.filterConfig,
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    createListingDraftError: propTypes.error,
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  categories: arrayOf(
    shape({
      key: string.isRequired,
      label: string.isRequired,
    })
  ),
  roomtypes: arrayOf(
    shape({
      key: string.isRequired,
      label: string.isRequired,
    })
  ),
};
const EditListingDescriptionForm = EditListingDescriptionFormComponent;

export default compose(injectIntl)(EditListingDescriptionForm);
